import { Injectable } from '@angular/core';
import { IdampHttpClient } from '../common/IdampHttpClient';
import { HttpClient } from '@angular/common/http';
import { Observable, from } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ChangeLogService {

    constructor(
        private http: IdampHttpClient,
        private httpClient: HttpClient
    ) { }

    public GetApiChangeLog(): Observable<string> {
        const path = `changeLog`;
        return from(this.http.GetAsTextAsync(path));
    }

    public GetPortalChangeLog(): Observable<string> {
        // In development, fetch from local file, in production it will be served as static asset
        const changelogPath = './assets/changelog.txt';
        return this.httpClient.get(changelogPath, { responseType: 'text' });
    }
}
